import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone } from 'lucide-react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[#0a1628] py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="text-[#00bcd4] hover:text-[#00acc1] text-sm flex items-center gap-1 mb-4">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white" data-testid="privacy-policy-title">Privacy Policy</h1>
          <p className="text-white/70 mt-3">The Village at Athol Island</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16" data-testid="privacy-policy-content">
        <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
          Your privacy matters to us! At The Village (operated by Harbor Point Holdings), we want you to feel safe and comfortable while planning your Bahamian adventure with us.
        </p>

        <section className="mb-10">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">What We Collect</h2>
          <ul className="space-y-2 text-muted-foreground list-disc pl-6">
            <li>Your name, email, and phone number</li>
            <li>Booking details (tour dates, number of guests, special requests)</li>
            <li>Payment info (handled securely by trusted third-party processors)</li>
            <li>Website usage info through cookies and analytics</li>
            <li>Messages from our contact form</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">How We Collect It</h2>
          <ul className="space-y-2 text-muted-foreground list-disc pl-6">
            <li>Directly from you when booking or sending inquiries</li>
            <li>Automatically via website cookies to improve your experience</li>
            <li>Indirectly from third-party booking platforms</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">How We Use It</h2>
          <ul className="space-y-2 text-muted-foreground list-disc pl-6">
            <li>To process your booking and keep your account up to date</li>
            <li>To send confirmations and important updates about your tour</li>
            <li>To help prevent fraudulent transactions</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">Cookies</h2>
          <ul className="space-y-2 text-muted-foreground list-disc pl-6">
            <li>Help us remember your booking steps and preferences</li>
            <li>Make the website easier to navigate and more enjoyable</li>
          </ul>
          <p className="text-sm text-muted-foreground mt-3 italic">
            Tip: You can manage cookies in your browser, but some features may not work properly if disabled.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-serif text-2xl font-bold text-foreground mb-4">Your Rights</h2>
          <ul className="space-y-2 text-muted-foreground list-disc pl-6">
            <li>Request access to your data</li>
            <li>Correct any inaccuracies</li>
            <li>Ask for deletion under certain conditions</li>
          </ul>
        </section>

        <section className="p-6 bg-[#faf9f6] rounded-2xl border border-border/30">
          <h2 className="font-serif text-xl font-bold text-foreground mb-3">Contact Us Anytime</h2>
          <div className="flex flex-col sm:flex-row gap-4 text-muted-foreground">
            <a href="mailto:hello@thevillageatholisland.com" className="flex items-center gap-2 hover:text-[#00bcd4] transition-colors">
              <Mail className="w-4 h-4" /> hello@thevillageatholisland.com
            </a>
            <a href="tel:+12428256265" className="flex items-center gap-2 hover:text-[#00bcd4] transition-colors">
              <Phone className="w-4 h-4" /> +1 (242) 825-6265
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
